import { StorageResourceSchema } from '@/entities/common/StorageResource'
import { z } from '@/utils/zod'

const BaseActorSchema = z.object({
    name: z.string(),
})

export const UserActorSchema = BaseActorSchema.extend({
    type: z.literal('user'),
    userId: z.string(),
    image: StorageResourceSchema.nullable(),
})

export type UserActor = z.infer<typeof UserActorSchema>

export const ApiActorSchema = BaseActorSchema.extend({
    type: z.literal('api'),
    key: z.string(),
})

export type ApiActor = z.infer<typeof ApiActorSchema>

export const SystemActorSchema = BaseActorSchema.extend({
    type: z.literal('system'),
})

export type SystemActor = z.infer<typeof SystemActorSchema>

export const GuestActorSchema = BaseActorSchema.extend({
    type: z.literal('guest'),
})

export type GuestActor = z.infer<typeof GuestActorSchema>

export const ContactActorSchema = BaseActorSchema.extend({
    type: z.literal('contact'),
    nameNormalized: z.string(),
    nameSort: z.string(),
    contact: z.objectId().nullable(),
    image: StorageResourceSchema.nullable(),
    user: UserActorSchema.nullable(),
})

export type ContactActor = z.infer<typeof ContactActorSchema>

// Actor - App
export const AppActorSchema = z.discriminatedUnion('type', [ContactActorSchema, GuestActorSchema])

export const AppActorTypeSchema = z.enum(AppActorSchema.options.map((schema) => schema.shape.type.value))

export type AppActor = z.infer<typeof AppActorSchema>

export type AppActorType = AppActor['type']

// Actor - Audit
export const AuditActorSchema = z.discriminatedUnion('type', [
    UserActorSchema,
    ApiActorSchema,
    SystemActorSchema,
    GuestActorSchema,
])

export const AuditActorTypeSchema = z.enum(AuditActorSchema.options.map((schema) => schema.shape.type.value))

export type AuditActor = z.infer<typeof AuditActorSchema>

export type AuditActorType = AuditActor['type']

// Actor - All
export const ActorSchema = z.discriminatedUnion('type', [
    UserActorSchema,
    ApiActorSchema,
    SystemActorSchema,
    GuestActorSchema,
    ContactActorSchema,
])

export type Actor = z.infer<typeof ActorSchema>

export const ActorTypeSchema = z.enum(ActorSchema.options.map((schema) => schema.shape.type.value))

export type ActorType = Actor['type']

export const ACTOR_SYSTEM = {
    type: 'system',
    name: 'System',
} as const satisfies SystemActor

export const ACTOR_EVENTIM = {
    type: 'system',
    name: 'Eventim',
} as const satisfies SystemActor
